import React, { PureComponent } from 'react'
import { string, bool, number, object, func, shape, arrayOf, oneOfType } from 'prop-types'
import { Text, SvgGrid, PreRacePerformanceLine } from 'components'
import { applyFactor, scaleFactor, wheelsPDet1, performanceVsDeteriorationForDrivingStyle } from 'utils/chartFunctions'
import { max, filter } from 'lodash'
import { translate } from 'react-i18next'
import { PreRaceCard } from './PreRaceCard'

const svgViewBox = '0 0 145 67'
const viewBox = { x: 28.7, y: 0.5, width: 115.8, height: 58.3 }

@translate()
export class PreRaceWheelsCard extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        typeId: string.isRequired,
        icon: string.isRequired,
        name: string.isRequired,
        description: string.isRequired,
        performanceFactor: number.isRequired,
        deteriorationFactor: number.isRequired,
        selected: bool.isRequired,
        onSelect: func.isRequired,
        showAMToolPanel: bool.isRequired,
        onToggleAMToolPanel: func,
        curveParams: object.isRequired,
        curvesFactors: arrayOf(shape({
            x: oneOfType([number, func]),
            y: oneOfType([number, func])
        })),
        curveIndex: number.isRequired,
        performanceMax: number.isRequired,
        expectedAssetLife: number.isRequired,
        applyDrivingStyleFactor: bool,
        className: string,
    }

    static defaultProps = {
        selected: false,
        applyDrivingStyleFactor: false
    }

    componentWillMount() {
        const { curveParams, curvesFactors, curveIndex, performanceMax, expectedAssetLife, applyDrivingStyleFactor } = this.props
        let curvesFactorsWithDrivingStyle = null
        if (applyDrivingStyleFactor) {
            const pDet1 = wheelsPDet1(curveParams)
            const factorAggr = max(curvesFactors.map(f => f.y))
            curvesFactorsWithDrivingStyle = curvesFactors.map(({ x, y: factor }) => {
                const factorRelative = factor / factorAggr
                const factorFunc = y => performanceVsDeteriorationForDrivingStyle(y, factorRelative, pDet1)
                return { x, y: factorFunc }
            })
        } else {
            curvesFactorsWithDrivingStyle = curvesFactors
        }
        const curveFactors = curvesFactorsWithDrivingStyle[curveIndex]
        const maxXFactor = max(curvesFactors.map(f => f.x)) * 1.1
        const maxYFactor = max(curvesFactors.map(f => (typeof f === 'function' ? f(0) : f.y))) * 1.1
        this.scaledCurvesFactors = curvesFactorsWithDrivingStyle.map(({ x, y }) => ({ x: scaleFactor(x, 1 / maxXFactor), y: scaleFactor(y, 1 / maxYFactor) }))
        // reorder array to have the selected one at the end due to SVG does not have z-index
        this.scaledCurvesFactors = [...filter(this.scaledCurvesFactors, (x, i) => i !== curveIndex), this.scaledCurvesFactors[curveIndex]]
        this.yLabel = (applyFactor(curveFactors.y, performanceMax)).toFixed(1)
        this.yLabelOffset = applyFactor(this.scaledCurvesFactors[curveIndex].y, 1)
        this.xLabel = (applyFactor(curveFactors.x, expectedAssetLife)).toFixed(1)
        this.xLabelOffset = applyFactor(this.scaledCurvesFactors[curveIndex].x, 1)
        this.lastIndex = curvesFactors.length - 1
    }

    renderCurve = (factors, index) => {
        const { curveParams } = this.props
        return (
            <PreRacePerformanceLine
                key={index}
                className={{ Selected: index === this.lastIndex, NotSelected: index !== this.lastIndex }}
                curveParams={curveParams}
                outputViewBox={viewBox}
                factors={factors}
                clipPath="url(#viewBoxClip)"
            />
        )
    }

    renderAMToolPanel = () => {
        const { onToggleAMToolPanel, selected, t } = this.props
        return (
            <div onClick={onToggleAMToolPanel}>
                <Text className="ChartLegend Y">{t('game.PRE_RACE.panelAMToolLineChartYLabel')}</Text>
                <svg className={{ WhiteBg: !selected }} viewBox={svgViewBox}>
                    <SvgGrid
                        viewBox={viewBox}
                        zeroLabel="0"
                        xLabel={this.xLabel}
                        xLabelOffset={this.xLabelOffset}
                        yLabel={this.yLabel}
                        yLabelOffset={this.yLabelOffset}
                        clipId="viewBoxClip"
                    />
                    {this.scaledCurvesFactors.map(this.renderCurve)}
                </svg>
                <Text className="ChartLegend X">{t('game.PRE_RACE.panelAMToolLineChartXLabel')}</Text>
            </div>
        )
    }

    render() {
        const { performanceFactor, deteriorationFactor, selected, curveParams, curvesFactors, curveIndex, performanceMax, expectedAssetLife, applyDrivingStyleFactor, onToggleAMToolPanel, className, t, tReady, ...otherProps } = this.props
        return (
            <PreRaceCard
                className={['PreRaceWheelsCard', className]}
                selected={selected}
                amToolContent={this.renderAMToolPanel()}
                {...otherProps}
            />
        )
    }
}



// WEBPACK FOOTER //
// src/components/Cards/PreRaceCard/PreRaceWheelsCard.js